export const GET_CHAT_PROVIDER = '@chatConnect/GET_CHAT_PROVIDER'
export const GET_AUTH_STATUS = '@chatConnect/GET_AUTH_STATUS'
export const GET_QRCODE_WPP_WEB = '@chatConnect/GET_QRCODE_WPP_WEB'
export const SET_CONNECTION_STATUS = '@chatConnect/SET_CONNECTION_STATUS'
